/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_SystemAlertConfigurationDto } from '../models/PagedResultDto_SystemAlertConfigurationDto';
import type { Wealthlane_Dtos_SystemAlertConfiguration_CreateSystemAlertConfigurationDto } from '../models/Wealthlane_Dtos_SystemAlertConfiguration_CreateSystemAlertConfigurationDto';
import type { Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto } from '../models/Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto';
import type { Wealthlane_Dtos_SystemAlertConfiguration_UpdateSystemAlertConfigurationDto } from '../models/Wealthlane_Dtos_SystemAlertConfiguration_UpdateSystemAlertConfigurationDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SystemAlertConfigurationService {

    /**
     * @param id 
     * @returns Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppSystemAlertConfiguration(
id: string,
): CancelablePromise<Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/system-alert-configuration/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto OK
     * @throws ApiError
     */
    public static putApiIdentityApiAppSystemAlertConfiguration(
id: string,
requestBody?: Wealthlane_Dtos_SystemAlertConfiguration_UpdateSystemAlertConfigurationDto,
): CancelablePromise<Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/identity/api/app/system-alert-configuration/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static deleteApiIdentityApiAppSystemAlertConfiguration(
id: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/identity/api/app/system-alert-configuration/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_SystemAlertConfigurationDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppSystemAlertConfigurationPaginatedList(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_SystemAlertConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/system-alert-configuration/paginated-list',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiAppSystemAlertConfigurationActive(): CancelablePromise<Array<Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/app/system-alert-configuration/active',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiAppSystemAlertConfiguration(
requestBody?: Wealthlane_Dtos_SystemAlertConfiguration_CreateSystemAlertConfigurationDto,
): CancelablePromise<Wealthlane_Dtos_SystemAlertConfiguration_SystemAlertConfigurationDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/app/system-alert-configuration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
